
  import info from "@/components/_universal/list-info.vue";
  import tablelist from "@/components/_universal/list-table.vue";

  // Standard Components
  import EVENTS from "@/constants/events";

  // Controller
  import PricingController from "@/controllers/pricing-controller";
  import listMixin from "@/mixin/list-mixin";

  // Initialize the PricingController instance (reuse same instance)
  const pricingController = new PricingController();

  export default {
    mixins: [listMixin],
    data() {
      return {
        listDataObj: {},
        EVENT_ACTION: {},
        project: {},
        timer: null,         // Holds the interval timer ID.
        apiCallCount: 0,     // Tracks the total number of API calls.
        unsubscribe: null,   // Holds the Vuex subscription function.
      };
    },
    methods: {
      async onFilterChange() {
        // Get current filter from store if available.
        if (this.$store.getters.getList.filter) {
          this.filter = this.$store.getters.getList.filter;
        }
        // Call API via the controller.
        let data = await pricingController.getListResults(this.filter);
        // Update the Vuex store with the API results.
        await this.updateResults(data.resources);
      },
      async loadData() {
        // Load initial list data from the controller.
        this.listDataObj = await pricingController.list();
        // If successful, update the store.
        if (this.listDataObj.table.data.success) {
          this.updateResults(this.listDataObj.table.data.resources);
        }
      },
      async updateResults(results) {
        // Dispatch the new list results to the Vuex store.
        this.$store.dispatch("setList", results);
      },
      subscribeOnFilterChange() {
        // Subscribe to Vuex mutations to refresh the list on filter changes.
        this.unsubscribe = this.$store.subscribe((mutation, state) => {
          if (mutation.type === "setFilter") {
            this.onFilterChange();
          }
        });
      },
    },
    components: {
      info,
      tablelist,
    },
    async mounted() {
      // Subscribe to filter changes.
      this.subscribeOnFilterChange();

      // Set up a timer to call onFilterChange every 20 seconds.
      this.timer = setInterval(async () => {
        // If API call limit (30 calls) is reached, clear the timer.
        if (this.apiCallCount >= 30) {
          clearInterval(this.timer);
          this.timer = null;
          
          return;
        }
        await this.onFilterChange();
        this.apiCallCount++;
        
      }, 20000);
    },
    async created() {
      // Set event constants.
      this.EVENT_ACTION = EVENTS;
      // Load initial data.
      await this.loadData();
    },
    beforeDestroy() {
      // Clean up Vuex store data.
      this.updateResults(null);
      // Unsubscribe from store changes.
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      // Clear the timer if it exists.
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  };
